import create from 'zustand';
import produce from 'immer';

const EXAM_REVIEW_INITIAL = {
	take: {
		id: 0,
		state: '',
		score: 0,
		mark: 0,
		startDate: '',
		endDate: '',
		startedAt: '',
		endedAt: ''
	},

	exam: {
		id: 0,
		slug: '',
		duration: 0,
		title: '',
		description: ''
	},

	subject: {
		id: 0,
		title: ''
	},

	student: {
		id: 0,
		slug: '',
		avatar: '',
		fullName: '',
		status: ''
	},

	tasks: [],

	answers: [],

	summaries: []
};

export const useExamReviewStore = create(set => ({
	...EXAM_REVIEW_INITIAL,

	// Handle take change
	onChange: ({ name, value }) => set(produce((state) => {
		state.take[name] = value;
	})),
	
	// Handle answer change
	onChangeAnswer: (id, { name, value }) => set(produce((state) => {
		const answer = state.answers.find(a => a.id === id);
		answer[name] = value;

		if (name === 'score') {
			const summary = state.summaries.find(s => s.taskId === answer.taskId);
			const answers = state.answers.filter(a => a.taskId === answer.taskId);
			summary.score = answers.reduce((total, answer) => total += Number(answer.score), 0);
			state.take.score = state.summaries.reduce((total, summary) => total += Number(summary.score), 0);
		}
	})),

	// Handle task's summary change
	onChangeSummary: (id, { name, value }) => set(produce((state) => {
		const summary = state.summaries.find(s => s.id === id);
		summary[name] = value;
	})),

	// Initialize exam's state
	onInit: (take) => set((state) => ({
		take: {
			id: take.id,
			state: take.state,
			score: take.score,
			mark: take.mark,
			startDate: take.startDate,
			endDate: take.endDate,
			startedAt: take.startedAt,
			endedAt: take.endedAt
		},

		exam: take?.exam ? {
			id: take.exam?.id,
			slug: take.exam?.slug,
			duration: take.exam?.duration,
			title: take.exam?.title,
			description: take.exam?.description
		}	: {
			...state.exam
		},

		subject: take?.exam?.subject ? {
			id: take.exam.subject?.id,
			title: take.exam.subject?.title
		} : {
			...state.subject
		},

		student: take?.student ? {
			id: take.student.id,
			slug: take.student.slug,
			avatar: take.student.avatar,
			fullName: take.student.fullName,
			status: take.student.status
		} : state.student,

		tasks: take?.exam?.tasks,

		answers: take?.answers,

		summaries: take?.summaries
	})),

	// Reset store to initial state
	onReset: () => set({
		...EXAM_REVIEW_INITIAL
	})
}));